module.exports = __webpack_public_path__ + "media/images/icons/file-90b578b8844e988a78d037e248d0b290.svg";